import { React, useEffect, useState } from "react";

//ANT DESIGN IMPORTS
import {
    Input,
    Row,
    Typography,
    Form,
    Col,
    Select,
    InputNumber,
    Divider,
    Tooltip,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { labelConfig, staticConfig } from "../../../../group.config";


//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import styles from "../../../../../../assets/styles/styles";

const { Text, Title } = Typography;

const TermsForm = (props) => {
    const {
        onFinish,
        form,
        initialValues,
        interestCompoundingPeriodTypeOptions,
        interestPostingPeriodTypeOptions,
        interestCalculationTypeOptions,
        interestCalculationDaysInYearTypeOptions,
        handleOverdarftAllowed,
        handleLienAllowed,
        lockinPeriodFrequencyTypeOptions,
        isLockInDefined,
        handleLockInPeriod,
        isLienAllowed,
        isMinReqBalEnforced,
        handleEnforceMin,
        isOverdraftAllowed,
    } = props;

    return (
        <Form
            layout="vertical"
            onFinish={onFinish}
            form={form}
            initialValues={initialValues}
        >
            <Row>
                <Divider orientation="left" orientationMargin="0">
                    <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                        {labelConfig.currencyInfo}
                    </Title>
                </Divider>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.currency}
                        name="currency"
                    >
                        <Input
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.currency
                            )}
                            disabled
                            className="of-bold-disable-input"

                        />
                    </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.decimalPlaces}
                        name="decimalPlaces"
                    >
                        <Input
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.decimalPlaces
                            )}
                            disabled
                            className="of-bold-disable-input"

                        />
                    </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.currencyInMultiplesOf}
                        name="currencyInMultiplesOf"
                    >
                        <Input
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.currencyInMultiplesOf
                            )}
                            disabled
                        />
                    </Form.Item>
                </Col>
                <Divider orientation="left" orientationMargin="0">
                    <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                        {labelConfig.interestInfo}
                    </Title>
                </Divider>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.nominalAnnualInterest}
                        name="nominalAnnualInterestRate"
                        rules={[
                            {
                                required: true,
                                message: BOM.CheckReqFld(labelConfig.nominalAnnualInterest),
                            },
                        ]}
                    >
                        <Input
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.nominalAnnualInterest
                            )}
                        />
                    </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.interestCompoundingPeriod}
                        name="interestCompoundingPeriodType"
                        rules={[
                            {
                                required: true,
                                message: BOM.CheckReqFld(labelConfig.interestCompoundingPeriod),
                            },
                        ]}
                    >
                        <Select
                            filterOption={(input, option) =>
                                (option?.label?.toLowerCase() ?? "").includes(
                                    input?.toLowerCase()
                                )
                            }
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.interestCompoundingPeriod,
                                "select"
                            )}
                            options={interestCompoundingPeriodTypeOptions}
                            showSearch
                        />
                    </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.interestPostingPeriod}
                        name="interestPostingPeriodType"
                        rules={[
                            {
                                required: true,
                                message: BOM.CheckReqFld(labelConfig.interestPostingPeriod),
                            },
                        ]}
                    >
                        <Select
                            filterOption={(input, option) =>
                                (option?.label?.toLowerCase() ?? "").includes(
                                    input?.toLowerCase()
                                )
                            }
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.interestPostingPeriod,
                                "select"
                            )}
                            options={interestPostingPeriodTypeOptions}
                            showSearch
                        />
                    </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.interestCalculatedUsing}
                        name="interestCalculationType"
                        rules={[
                            {
                                required: true,
                                message: BOM.CheckReqFld(labelConfig.interestCalculatedUsing),
                            },
                        ]}
                    >
                        <Select
                            filterOption={(input, option) =>
                                (option?.label?.toLowerCase() ?? "").includes(
                                    input?.toLowerCase()
                                )
                            }
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.interestCalculatedUsing,
                                "select"
                            )}
                            options={interestCalculationTypeOptions}
                            showSearch
                        />
                    </Form.Item>
                </Col>
                <Divider orientation="left" orientationMargin="0">
                    <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                        {labelConfig.additionalInfo}
                    </Title>
                </Divider>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.daysInYear}
                        name="interestCalculationDaysInYearType"
                        rules={[
                            {
                                required: true,
                                message: BOM.CheckReqFld(labelConfig.daysInYear),
                            },
                        ]}
                    >
                        <Select
                            filterOption={(input, option) =>
                                (option?.label?.toLowerCase() ?? "").includes(
                                    input?.toLowerCase()
                                )
                            }
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.daysInYear,
                                "select"
                            )}
                            options={interestCalculationDaysInYearTypeOptions}
                            showSearch
                        />
                    </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.minimumOpeningBalance}
                        name="minRequiredOpeningBalance"
                    >
                        <Input
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.minimumOpeningBalance
                            )}
                        />
                    </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.lockInPeriod}
                        name="lockinPeriodFrequency"
                    >
                        <Input
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.lockInPeriod
                            )}
                            onChange={handleLockInPeriod}
                        />
                    </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.lockInPeriodType}
                        name="lockinPeriodFrequencyType"
                        rules={[
                            {
                                required: isLockInDefined,
                                message: BOM.CheckReqFld(labelConfig.lockInPeriodType),
                            },
                        ]}
                    >
                        <Select
                            filterOption={(input, option) =>
                                (option?.label?.toLowerCase() ?? "").includes(
                                    input?.toLowerCase()
                                )
                            }
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.lockInPeriodType,
                                "select"
                            )}
                            options={lockinPeriodFrequencyTypeOptions}
                            showSearch
                            allowClear
                        />
                    </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={
                            <Tooltip
                                title={labelConfig.applyWithdrawalFeeForTransfers}
                            >
                                {BOM.SubstringFormat(
                                    labelConfig.applyWithdrawalFeeForTransfers,
                                    20
                                )}
                            </Tooltip>
                        }
                        name="withdrawalFeeForTransfers"
                    >
                        <Select
                            filterOption={(input, option) =>
                                (option?.label?.toLowerCase() ?? "").includes(
                                    input?.toLowerCase()
                                )
                            }
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.applyWithdrawalFeeForTransfers,
                                "select"
                            )}
                            options={staticConfig.yesOrNoData}
                            showSearch
                        />
                    </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.isOverdraftAllowed}
                        name="allowOverdraft"
                    >
                        <Select
                            filterOption={(input, option) =>
                                (option?.label?.toLowerCase() ?? "").includes(
                                    input?.toLowerCase()
                                )
                            }
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.isOverdraftAllowed,
                                "select"
                            )}
                            options={staticConfig.yesOrNoData}
                            onChange={handleOverdarftAllowed}
                        />
                    </Form.Item>
                </Col>
                {isOverdraftAllowed && (
                    <>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                label={labelConfig.maxOverdraftAmtLimit}
                                name="overdraftLimit"
                            >
                                <Input
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.maxOverdraftAmtLimit
                                    )}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                label={
                                    <Tooltip
                                        title={labelConfig.nominalAnnualIntrstForOverdraft}
                                    >
                                        {BOM.SubstringFormat(
                                            labelConfig.nominalAnnualIntrstForOverdraft,
                                            20
                                        )}
                                    </Tooltip>
                                }
                                name="nominalAnnualInterestRateOverdraft"
                            >
                                <Input
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.nominalAnnualIntrstForOverdraft
                                    )}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                label={
                                    <Tooltip
                                        title={labelConfig.minOverdraftForIntrstCalc}
                                    >
                                        {BOM.SubstringFormat(
                                            labelConfig.minOverdraftForIntrstCalc,
                                            20
                                        )}
                                    </Tooltip>
                                }
                                name="minOverdraftForInterestCalculation"
                            >
                                <Input
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.minOverdraftForIntrstCalc
                                    )}
                                />
                            </Form.Item>
                        </Col>
                    </>
                )}
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.isLienAllowed}
                        name="lienAllowed"
                    >
                        <Select
                            filterOption={(input, option) =>
                                (option?.label?.toLowerCase() ?? "").includes(
                                    input?.toLowerCase()
                                )
                            }
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.isLienAllowed,
                                "select"
                            )}
                            options={staticConfig.yesOrNoData}
                            onChange={handleLienAllowed}
                        />
                    </Form.Item>
                </Col>
                {isLienAllowed &&
                    <Col span={8} style={{ padding: "0px 8px" }}>
                        <Form.Item
                            label={labelConfig.maxLienAmtLimit}
                            name="maxAllowedLienLimit"
                            rules={[
                                {
                                    required: true,
                                    message: BOM.CheckReqFld(labelConfig.maxLienAmtLimit),
                                },
                            ]}
                        >
                            <Input
                                placeholder={BOM.handlePlaceholderMsg(
                                    labelConfig.maxLienAmtLimit
                                )}
                            />
                        </Form.Item>
                    </Col>
                }
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.enforceMinimumBalance}
                        name="enforceMinRequiredBalance"
                    >
                        <Select
                            filterOption={(input, option) =>
                                (option?.label?.toLowerCase() ?? "").includes(
                                    input?.toLowerCase()
                                )
                            }
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.enforceMinimumBalance,
                                "select"
                            )}
                            options={staticConfig.yesOrNoData}
                            onChange={handleEnforceMin}
                        />
                    </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.minimumBalance}
                        name="minimumBalance"
                        rules={[
                            {
                                required: isMinReqBalEnforced,
                                message: BOM.CheckReqFld(labelConfig.maxLienAmtLimit),
                            },
                        ]}
                    >
                        <Input
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.minimumBalance
                            )}
                        />
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};

export default TermsForm;
